export default function TextareaField({
  id,
  name,
  className,
  label,
  value,
  rows,
  onChange,
  isInvalid,
  error,
  help,
  labelStyle,
  disabled,
  maxLength,
  ...props
}) {
  const computedClassName = [
    "form-group",
    "textarea-field",
    isInvalid ? "has-error" : "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      <label for={id} style={labelStyle} className="control-label">
        {label}
      </label>
      <textarea
        id={id}
        name={name}
        value={value || ""}
        rows={rows}
        className="form-control"
        maxLength={maxLength}
        onChange={onChange}
        aria-invalid={isInvalid}
        disabled={disabled}
      />
      {isInvalid && !!error && <span className="help-block">{error}</span>}
    </div>
  );
}

TextareaField.defaultProps = {
  className: "",
  onChange: (event) => {},
  rows: 3,
};
